import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const RoleBasedRoute = ({ currentUserRole, allowedRoles = [] }) => {
  return !allowedRoles.length || allowedRoles.includes(currentUserRole) ? (
    <Outlet />
  ) : (
    <Navigate to="/" />
  );
};

export default RoleBasedRoute;
